import { Button, Icon } from '@homebotapp/hb-react-component-catalog'
import { FormattedMessage } from 'react-intl'

export const SeeAllListingsDisabledButton = () => {
  return (
    <Button
      isDisabled={true}
      rightIcon={<Icon name='circle-arrow-right-bts' width='12px' height='12px' />}
      size='sm'
      colorScheme='primary'
      ml={2}
      mb={2}
    >
      <FormattedMessage id='HomeSearch.savedSearches.noHomes' defaultMessage='No homes' />
    </Button>
  )
}
